module.exports = __webpack_public_path__ + "assets/2ce260e5d1b3665f329b4f3578db558e.png";